// Firebase web config (public by design; access is enforced by the security
// rules in firestore.rules and storage.rules).
export const FIREBASE_PROJECT_ID = "mac-portfolio-3a56b";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "mac-portfolio-3a56b.firebaseapp.com",
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: "mac-portfolio-3a56b.firebasestorage.app",
  messagingSenderId: "569080617747",
  appId: "1:569080617747:web:78ff432fa0ba47358698e6",
  measurementId: "G-VJYQN03EW8",
};

// Only this Google account can write work media. Keep in sync with the rules.
export const ADMIN_EMAIL = "chebbi603@gmail.com";
